import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import KBTOCDto from '@/models/KnowledgeBase/KBTOCDto';
import UpdateTOCDraftRequest from '@/models/KnowledgeBase/UpdateTOCDraftRequest';
import PublishContentRequest from '@/models/KnowledgeBase/PublishContentRequest';

export interface ISysKBTOCDetailsState {
  loading: boolean;
  toc: KBTOCDto | null;
  loadingDialog: boolean;
}

@Module({ dynamic: true, store, name: 'SysKBTOCDetails', namespaced: true })
class SysKBTOCDetails extends VuexModule implements ISysKBTOCDetailsState {

  public loading = false;
  public toc: KBTOCDto | null = null;
  public loadingDialog = false;

  @Action
  async getTOC(tocId: string) {
    this.setLoading(true);
    return ajax.get(`/api/v1/sys/kb/toc/${tocId}`)
      .then(response => {
        this.context.commit('setTOC', response.data);
        this.setLoading(false);
        return response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoading(false);
        throw error;
      });
  }

  @Action
  async updateTOCDraft(params: { tocId: string; request: UpdateTOCDraftRequest }) {
    this.setLoadingDialog(true);
    return ajax.put(`/api/v1/sys/kb/toc/${params.tocId}/draft`, params.request)
      .then(response => {
        this.setLoadingDialog(false);
        // Refresh TOC
        this.getTOC(params.tocId);
        return response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoadingDialog(false);
        throw error;
      });
  }

  @Action
  async publishTOC(params: { tocId: string; request: PublishContentRequest }) {
    this.setLoadingDialog(true);
    return ajax.post(`/api/v1/sys/kb/toc/${params.tocId}/publish`, params.request)
      .then(response => {
        this.setLoadingDialog(false);
        // Refresh TOC
        this.getTOC(params.tocId);
        return response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoadingDialog(false);
        throw error;
      });
  }

  @Action
  cleanState() {
    this.context.commit('resetState');
  }

  @Mutation
  resetState() {
    this.toc = null;
    this.loading = false;
    this.loadingDialog = false;
  }

  @Mutation
  private setLoading(loading: boolean) {
    this.loading = loading;
  }

  @Mutation
  private setTOC(toc: KBTOCDto) {
    this.toc = toc;
  }

  @Mutation
  private setLoadingDialog(loading: boolean) {
    this.loadingDialog = loading;
  }
}

export const SysKBTOCDetailsModule = getModule(SysKBTOCDetails);
